module.exports = __webpack_public_path__ + "img/Flag_of_Saint_Vincent_and_the_Grenadines.c4b654be.svg";